module.exports = __webpack_public_path__ + "static/2-4bf0a289cda516b7587a5b4b048d2f27.jpeg";